import React from 'react'
import bg from "../images/IMG_0095.jpg";
import Nav from '../components/Nav'
import super_executive from "../images/superexecutive_room.JPG"
import super_dulex from "../images/superdulex_room.JPG"
import honeymoon from "../images/honeymoon_room.JPG"
import president from "../images/president_room.JPG"
import reception from "../images/reception.JPG"
import reception1 from "../images/reception1.webp"
import gal2 from "../images/gal2.JPG"
import gal3 from "../images/gal3.JPG"
import Footer from '../components/Footer'
const GALLERY=[gal2,reception1,super_executive,honeymoon,president,reception,bg,gal3,super_dulex]
const Gallery = () => {
  return (
    <div>
       
        <div className="h-3/4 bg bg-center bg-cover">
        <div className="h-full z-10 overlay">
          <Nav/>
          <div className="container landing mx-auto z-10 text-center text-white">
            <p className="text-4xl">GALLERY</p>
          </div>
          </div>
          </div>
        
 <div  className=" p-10 container mx-auto md:grid grid-cols-3 gap-4 grid-flow-row sm:flex flex-col">
{GALLERY.map((e,i)=>{
            return(
          <div key={i} className="bg-cover place-self-center">
            <img src={e} alt="bg"/>
          </div>
       
            )
        })
    }   
    </div>
        <Footer/>
    </div>
  )
}

export default Gallery